import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, Input } from '@angular/core';
import { FormatterService } from '@scripts/woo_services.module/FormatterService';
import { ModalService } from '@src/shared/modal/modal.service';
import { StopCampaignModalComponent } from '@src/views/dashboard/components/modal/stop-campaign-modal/stop-campaign-modal.component';
import { CampaignService } from '../../../../woo_services.module/CampaignService';
import { AttestStatus, Invoice, InvoiceService } from '../../../../woo_services.module/InvoiceService';
import { RoutingService } from '../../../../woo_services.module/RoutingService';
import { Campaign } from '../../../../woo_services.module/shared-types';

@Component({
  selector: 'stop-campaign-button',
  template: ` <text-button icon="close-x" [disabled]="disabled" (click)="onClick()"> Stoppa </text-button> `,
  standalone: false,
})
export class StopCampaignButton {
  formatterService = inject(FormatterService);
  @Input() campaign: Campaign;
  @Input() disabled = false;

  constructor(
    private campaignService: CampaignService,
    private modalService: ModalService,
    private routingService: RoutingService,
    private invoiceService: InvoiceService,
  ) {}

  onClick = (): void => {
    if (this.disabled) {
      return;
    }

    const dialog = this.modalService.openCustom(StopCampaignModalComponent, {
      initialOrderValue: this.campaign.order_value,
    });

    dialog.componentInstance.submit.subscribe((data) => {
      this.stopCampaign(this.campaign, data.comment, data.newOrderValue);
      dialog.close();
    });
  };

  private stopCampaign = (campaign: Campaign, comment: string, newOrderValue: number) => {
    const loaderModal = this.modalService.openLoader('Stoppar kampanjen');
    this.campaignService
      .stop(campaign.id, comment, newOrderValue)
      .then(
        (campaign: Campaign) => {
          this.invoiceService
            .getInvoicesForCampaign(campaign.id)
            .then((invoices: Invoice[]) => {
              const newCreditInvoices = invoices.filter((invoice) => {
                return invoice.status === 'created' && invoice.attest_status === AttestStatus.AwaitingAttest;
              });
              if (newCreditInvoices.length !== 0) {
                this.modalService.openSuccess(
                  'Kampanjen har stoppats.',
                  'Kreditfaktura är skapad!',
                  'Ni måste skapa ett Scrive-underlag för att ekonomi ska kunna godkänna denna kreditfaktura.',
                );
              } else {
                this.modalService.openSuccess('Kampanjen har stoppats.');
              }
            })
            .catch(() => {
              this.modalService.openError('Ajdå, något gick snett. Din kampanj kunde inte stoppas.');
            })
            .finally(() => {
              loaderModal.close();
              this.routingService.navigate(['/dashboard']);
            });
        },
        (reason) => {
          if (!(reason instanceof HttpErrorResponse)) {
            this.modalService.openError('Ajdå, något gick snett. Din kampanj kunde inte stoppas.');
          }
        },
      )
      .catch(() => {
        this.modalService.openError('Ajdå, nånting gick snett. Testa att refresha browsern och försök igen.');
      })
      .finally(() => {
        loaderModal.close();
      });
  };
}
